module.exports = __webpack_public_path__ + "static/media/Maths.eb8b3622.svg";